import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, provide, watch, computed } from "vue"; 
import { useGoogleMaps } from '@/store/googleMaps';
import { MapProvider } from "@/components/Maps/index";
import { useOrganizations } from "@/store/organizations";
import { useAuth } from "@/store/auth"
import { type Organizations, type DataInstance } from "@/platform-data";
type Emits = {
	(e: "moveToLogin",from:string):void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'map-tool',
  emits: ["moveToLogin"],
  setup(__props, { expose: __expose, emit }) {
  __expose();

const { waitForReady, useMap } = useGoogleMaps();
const auth = useAuth();

const gMaps = useGoogleMaps();

const filters = [
  "ALS AWARENESS",
  "FUNDS ALS RESEARCH",
  "CONDUCTS ALS RESEARCH",
  "ADAPTIVE TECH OEM",
  "FUNDS HOME CARE",
  "IN PERSON SUPPORT GROUPS",
  "PRIMARILY ALS FOCUSED",
  "NON ALS FOCUSED",
  "RELATED DISEASE",
  "ALS DATABASE SYSTEM",
  "CONSORTIA",
  "ONLINE INFO SOURCE",
  "ONLINE SUPPORT GROUPS",
  "VETERANS RESOURCE",
  "CHILDRENS RESOURCES",
  "NON PROFIT",
  "FOR PROFIT",
  "GOVERNMENT ENTITY",
  "POLICY OFFICERS",
  "DRUG DEVELOPER / STAGE",
  "VENTURE CAPITAL",
  "PUBLICATIONS",
  "ALTERNATIVE THERAPY",
  "INTERNATIONAL"
];


const organizations = useOrganizations();

const searchQuery = ref("");
const showSuggestions = ref(false);

const mapContainer = ref<HTMLElement | null>(null);
const mapInstance = ref<google.maps.Map>();

provide(MapProvider, mapInstance);

console.log("MapTool component is loading...");

function moveToLogin(){
	emit("moveToLogin","map");
}

onMounted(async()=>{
	await organizations.waitForReady();
	await waitForReady();
	await auth.waitForReady();

	if (!mapContainer.value) {
		console.error("Map container is not available.");
		return;
	}
	const { map } = useMap(mapContainer.value);
	mapInstance.value = map

	if (!map) {
		console.error("Failed to initialize Google Map.");
	}

	if (mapInstance.value) {
		mapInstance.value.setCenter({ lat: 33.228819, lng: -41.979093 });
		mapInstance.value.setZoom(4);
	} else {
		console.error("Map instance is null.");
	}
})

const searchResults = computed(() => {
  if (!searchQuery.value.trim()) return [];

  return organizations.filteredOrganizations
    .filter(org => org["Organization Name"].toLowerCase().includes(searchQuery.value.toLowerCase()))
    .map(org => ({
      id: org.$id,
      name: org["Organization Name"],
      lat: org.lat,
      lng: org.lng,
    }));
});

const selectedFilter = ref<string | null>(null);

const filteredOrganizations = computed(() => {
  let filtered = organizations.filteredOrganizations;

  if (selectedFilter.value) {
    filtered = filtered.filter(org => org[selectedFilter.value] === true);
  }

  return filtered.filter(org => typeof org.lat === "number" && typeof org.lng === "number" && !isNaN(org.lat) && !isNaN(org.lng));
});

function applyFilter(filterName: string) {
  selectedFilter.value = selectedFilter.value === filterName ? null : filterName;
}

function selectSuggestion(org: DataInstance<Organizations.Model>) {
  searchQuery.value = org["Organization Name"];
  showSuggestions.value = false;

  if (mapInstance.value) {
    mapInstance.value.setCenter({ lat: org.lat, lng: org.lng });
    mapInstance.value.setZoom(10);
  }

/* Need to figure out how to set detail view correctly */
//   gMaps.setOrgDetails(org);
}


function hideSuggestions() {
	setTimeout(() => {
		showSuggestions.value = false;
	}, 200);
}

function adjustZoom(newZoom: number) {
	if (mapInstance.value) {
		mapInstance.value.setZoom(newZoom);
	}
}

watch(filteredOrganizations, (newFilteredOrgs) => {
  console.log("Filtered organizations updated:", newFilteredOrgs.length);
  gMaps.updateMapMarkers(newFilteredOrgs);
}, { immediate: true });

const __returned__ = { waitForReady, useMap, auth, gMaps, filters, emit, organizations, searchQuery, showSuggestions, mapContainer, mapInstance, moveToLogin, searchResults, selectedFilter, filteredOrganizations, applyFilter, selectSuggestion, hideSuggestions, adjustZoom, ref, onMounted, provide, watch, computed, get useGoogleMaps() { return useGoogleMaps }, get MapProvider() { return MapProvider }, get useOrganizations() { return useOrganizations }, get useAuth() { return useAuth } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})